import { transformDateValue } from 'core/js/FormUtils';
export const getRawdemandView = (dataList) => {
  
  const transformDataValue = (value, type) =>{
    if (!type.includes('date')) return value;
    return transformDateValue(value);
  }

  let rawdemandList = [];
  dataList.map((data)=>{
  let card = {
            'id': data.id,
            'headingList': [
                            {"fieldLabel":"title","fieldValue":transformDataValue(data.title,"string"), "fieldType":"string"},
                            {"fieldLabel":"Qty","fieldValue":transformDataValue(data.qty,"number"), "fieldType":"number"},
                            {"fieldLabel":"Status","fieldValue":transformDataValue(data.status,"string"), "fieldType":"string"},
                            {"fieldLabel":"Vendor Name","fieldValue":transformDataValue(data.vendorname,"string"), "fieldType":"string"},
                            {"fieldLabel":"Price","fieldValue":transformDataValue(data.price,"double"), "fieldType":"double"},
              
              
            ],
            'dataList': [
                
              ]
          }

          rawdemandList.push(card);
  })
  return rawdemandList;
}